import { FC, memo } from "react";
import { RecallModalProps } from "./types";
import { Button, Modal, Stack, Text, Image, Space } from "@mantine/core";
import ICON from "@/assets/images/pngs/remind.png";
import { useTranslation } from "react-i18next";

const RecallModal: FC<RecallModalProps> = ({ onConfirm, transactionTypeLabel, ...modalProps }) => {
  const { t } = useTranslation();

  // Precision theo Figma node 3193-42076 (scale về modal web app hiện có).
  return (
    <Modal
      {...modalProps}
      centered
      withCloseButton={false}
      size={400}
      radius={24}
      padding={30}
      styles={{
        content: { boxShadow: "0px 25px 50px -12px rgba(0,0,0,0.25)" },
      }}
    >
      <Stack align="center" spacing={0}>
        <Image
          src={ICON}
          style={{ width: 96, height: 96, objectFit: "contain" }}
        />
        <Space h={24} />
        <Text fw={700} fz={20} ta="center" c="#191C1E">
          {t("WITHDRAW_TRANSACTION")}
        </Text>
        <Space h={16} />
        <Text fz={14} lh="22px" ta="center" c="#414751">
          {transactionTypeLabel
            ? t("RECALL_TRANSACTION_CONFIRM_TYPED", { type: transactionTypeLabel })
            : t("RECALL_TRANSACTION_CONFIRM")}
        </Text>
        <Space h={28} />
        <Button
          fullWidth
          size="md"
          onClick={onConfirm}
          sx={() => ({
            borderRadius: 12,
            backgroundColor: "#0171BB",
            "&:hover": { backgroundColor: "#015a97" },
          })}
        >
          {t("WITHDRAW_TRANSACTION")}
        </Button>
        <Space h={16} />
        <Button
          variant="outline"
          fullWidth
          size="md"
          onClick={modalProps.onClose}
          sx={() => ({
            borderRadius: 16,
            borderColor: "#005AAA",
            color: "#003F7B",
            backgroundColor: "#FFFFFF",
          })}
        >
          {t("CANCEL_SHORT")}
        </Button>
      </Stack>
    </Modal>
  );
};

export default memo(RecallModal);
